import { useState } from 'react'

import AutowidthInput from 'react-autowidth-input'
import { CheckIcon } from '@chakra-ui/icons'
import { Box, HStack, IconButton, Input, Text } from '@chakra-ui/react'

import { useIsAdmin, useTeam, useUpdateTeam } from '@/react-query/team'
import { PencilSvg } from '@/views/assets/PencilSvg'

export const TeamName = () => {
  const team = useTeam().data
  const updateTeam = useUpdateTeam()
  const [isEditing, setIsEditing] = useState(false)
  const [localTeamName, setLocalTeamName] = useState(team?.name)

  const isAdmin = useIsAdmin()
  return (
    <HStack alignItems={'center'} mt={10} fontSize={'24px'} fontWeight={'700'}>
      <Text>Team</Text>

      <Box>
        {isEditing ? (
          <Input
            minW={'100px'}
            pr={0}
            value={localTeamName}
            onChange={(e) => setLocalTeamName(e.target.value)}
            variant={'brand-solid-gray'}
            as={AutowidthInput}
            fontSize={'24px'}
          />
        ) : (
          <Text minW={'116px'} pr={4}>
            {team?.name}
          </Text>
        )}
      </Box>
      {isAdmin && (
        <IconButton
          onClick={async (e) => {
            e.preventDefault()
            if (isEditing) {
              updateTeam.mutate({ name: localTeamName || '' })
            } else {
              setLocalTeamName(team?.name)
            }
            setIsEditing((isEditing) => !isEditing)
          }}
          variant="brand-solid-gray"
          icon={isEditing ? <CheckIcon /> : <PencilSvg />}
          aria-label="Edit team name"
        />
      )}
    </HStack>
  )
}
